export default __webpack_public_path__ + "static/media/Montserrat-LightItalic.57ae4565.ttf";